<template>
  <div class="container-fluid">
    <div class="page-title">
      <h3>Stripe Connect</h3>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="!isTraveler" class="alert alert-warning mb-0">
          Esta sección está disponible para usuarios viajeros o administradores.
        </div>

        <template v-else>
          <div v-if="loading" class="text-muted">Cargando estado de conexión...</div>
          <div v-else-if="errorMsg" class="alert alert-danger">{{ errorMsg }}</div>
          <template v-else>
            <div class="row g-3">
              <div class="col-md-3">
                <div class="p-3 border rounded h-100">
                  <div class="small text-muted">Cuenta conectada</div>
                  <div class="fw-semibold">{{ status.connected ? 'Sí' : 'No' }}</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="p-3 border rounded h-100">
                  <div class="small text-muted">Onboarding</div>
                  <div class="fw-semibold">{{ status.onboardingCompleted ? 'Completado' : 'Pendiente' }}</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="p-3 border rounded h-100">
                  <div class="small text-muted">Cobros habilitados</div>
                  <div class="fw-semibold">{{ status.chargesEnabled ? 'Sí' : 'No' }}</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="p-3 border rounded h-100">
                  <div class="small text-muted">Payouts habilitados</div>
                  <div class="fw-semibold">{{ status.payoutsEnabled ? 'Sí' : 'No' }}</div>
                </div>
              </div>
            </div>

            <div class="mt-3 small text-muted">
              <div><strong>Account ID:</strong> {{ status.stripeAccountId || 'Aún no generado' }}</div>
            </div>

            <div class="d-flex gap-2 mt-4 flex-wrap">
              <button class="btn btn-primary" :disabled="actionLoading" @click="startOnboarding">
                {{ actionLoading ? 'Procesando...' : (status.connected ? 'Continuar onboarding' : 'Conectar con Stripe') }}
              </button>
              <button
                class="btn btn-outline-primary"
                :disabled="actionLoading || !status.connected"
                @click="openDashboard"
              >
                Abrir dashboard Stripe
              </button>
              <button class="btn btn-outline-secondary" :disabled="actionLoading" @click="loadStatus">
                Refrescar estado
              </button>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { stripeConnectApi } from '@/api/stripe-connect';

export default {
  name: 'StripeConnect',
  data() {
    return {
      loading: false,
      actionLoading: false,
      errorMsg: '',
      status: {
        connected: false,
        onboardingCompleted: false,
        chargesEnabled: false,
        payoutsEnabled: false,
        stripeAccountId: null,
      },
    };
  },
  computed: {
    role() {
      return this.$store.getters['auth/role'];
    },
    isTraveler() {
      return this.role === 'CONDUCTOR_VIAJERO' || this.role === 'ADMINISTRADOR';
    },
  },
  mounted() {
    if (this.isTraveler) this.loadStatus();
  },
  methods: {
    async loadStatus() {
      this.loading = true;
      this.errorMsg = '';
      try {
        const { data } = await stripeConnectApi.getStatus();
        this.status = {
          connected: Boolean(data?.connected),
          onboardingCompleted: Boolean(data?.onboardingCompleted),
          chargesEnabled: Boolean(data?.chargesEnabled),
          payoutsEnabled: Boolean(data?.payoutsEnabled),
          stripeAccountId: data?.stripeAccountId || null,
        };
      } catch (e) {
        this.errorMsg = e.response?.data?.message || 'No se pudo cargar el estado de Stripe Connect.';
      } finally {
        this.loading = false;
      }
    },
    async startOnboarding() {
      this.actionLoading = true;
      try {
        const { data } = await stripeConnectApi.createOnboardLink();
        if (!data?.url) throw new Error('Stripe no devolvió URL de onboarding.');
        window.location.href = data.url;
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.response?.data?.message || e.message || 'No se pudo iniciar onboarding.',
        });
      } finally {
        this.actionLoading = false;
      }
    },
    async openDashboard() {
      this.actionLoading = true;
      try {
        const { data } = await stripeConnectApi.createDashboardLink();
        if (!data?.url) throw new Error('Stripe no devolvió URL de dashboard.');
        window.open(data.url, '_blank', 'noopener');
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.response?.data?.message || e.message || 'No se pudo abrir el dashboard.',
        });
      } finally {
        this.actionLoading = false;
      }
    },
  },
};
</script>

